import { render, staticRenderFns } from "./khlr.vue?vue&type=template&id=02468b7d&scoped=true&"
import script from "./khlr.vue?vue&type=script&lang=js&"
export * from "./khlr.vue?vue&type=script&lang=js&"
import style0 from "./khlr.vue?vue&type=style&index=0&id=02468b7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02468b7d",
  null
  
)

export default component.exports